<script setup lang="ts">
interface Props {
  as?: string;
}

withDefaults(defineProps<Props>(), {
  as: "div",
});
</script>
<template>
  <component :is="as" class="border-border bg-card text-card-foreground rounded-md border">
    <slot></slot>
  </component>
</template>
